"use client";
// Imports
import Link from "next/link";
import Image from "next/image";

// Not Found — uses brand colors (not CMS theme vars) so it stays readable
// when GraphQL/theme globals fail and --foreground would otherwise be white.
export default function NotFound() {
  // Render
  return (
    <main className="flex flex-col items-center justify-center min-h-[70dvh] px-6 py-16 text-center bg-brand-wool text-brand-espresso">
      <div className="flex flex-col items-center max-w-lg gap-6">
        <div className="w-14 h-14 sm:w-16 sm:h-16" aria-hidden>
          <Image
            src="/brand/ras-rose.svg"
            alt=""
            width={64}
            height={64}
            className="object-contain w-full h-full"
            priority
          />
        </div>
        <div className="space-y-3">
          <h1 className="font-heading level-1 text-brand-espresso">
            Sorry.
            <br />
            We can&apos;t find that page
          </h1>
          <h2 className="font-heading level-3 text-brand-espresso/80">
            404 — Page not found
          </h2>
        </div>
        <Link
          className="font-body underline text-brand-espresso hover:text-brand-red-gum transition-colors"
          href="/"
        >
          Return home
        </Link>
      </div>
    </main>
  );
}
